import { useQuery } from "@tanstack/react-query";

import { searchDoctors } from "@/api/doctors";

export function useDoctors(searchByNpiOrName?: string, enabled = true) {
  return useQuery({
    queryKey: ["doctor", "getDoctorsQuery", searchByNpiOrName],
    queryFn: () => searchDoctors(searchByNpiOrName),
    enabled,
  });
}
